export const loginFormDefaultValues = {
  mobile: "",
};
